import React, {useState} from 'react';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { 
	Form, 
	Input, 
	Button, 
	Typography, 
	Checkbox, 
	message 
} from 'antd';
import axiosInstance from '../../utils/axios';

const { Title } = Typography;

const Login = () => {
	const navigate = useNavigate();
	const [isRemember, setIsRemember] = useState(false);

	const [loading, setLoading] = useState(false);
	const [messageApi, contextHolder] = message.useMessage();

	const handleChange = (e) => {
		setIsRemember(e.target.checked);
	}

	const onFinish = async (values) => {
		setLoading(true);
		localStorage.setItem("remember_me", isRemember);

		try {
			const res = await axiosInstance.post(`accounts/login/?remember_me=${isRemember}`, values);
			setLoading(false);
			localStorage.setItem('name', res.data.name);
			localStorage.setItem('logged_in', true);
			localStorage.setItem('user_role', res.data.role);
			localStorage.setItem('access_token', res.data.access_token);
			localStorage.setItem('refresh_token', res.data.refresh_token);
			axiosInstance.defaults.headers['Authorization'] = 'Bearer ' + res.data.access_token;
			navigate('/dashboard'); // This will be caught by RoleRedirect component
		} catch (err) {

			if (err.response && err.response.data) {
				messageApi.open({
					type: 'error',
					content: err.response.data.message || err.response.data.detail || "Please check fields or may be user is inactive",
				  });
			}
			setLoading(false);
		}
	};

	const onFinishFailed = errorInfo => {
		console.log('Failed:', errorInfo);
	};

	return (
		<>	
			{contextHolder}
			{/* Logo and branding */}
			<div style={{ textAlign: 'center', marginBottom: 32 }}>
				<div style={{
					width: 48,
					height: 48,
					margin: '0 auto 8px',
					backgroundColor: '#6366f1',
					borderRadius: 12,
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center'
				}}>
					<span style={{ color: 'white', fontWeight: 'bold' }}>∞</span>
				</div>
				<Title level={3} style={{ marginBottom: 0 }}>Welcome to Getam</Title>
			</div>

			{/* Sign in form */}
			<div style={{ marginBottom: 24 }}>
				<Title level={4} style={{ margin: 0 }}>Sign in</Title>
			</div>
			<Form
				name="login"
				layout="vertical"
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
			>
				<Form.Item
					label="Email"
					name="email"
					// rules={[{ required: true, message: 'Please enter your email!' }]}
				>
					<Input
						type='email'
						size="large"
						placeholder="Enter your email"
						style={{ borderRadius: 8 }}
						autoComplete="username"
					/>
				</Form.Item>

				<Form.Item
					label="Password"
					name="password"
					// rules={[{ required: true, message: 'Please enter your password!' }]}
				>
					<Input.Password
						size="large"
						placeholder="Enter your password"
						iconRender={visible => visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />}
						style={{ borderRadius: 8 }}
						autoComplete="current-password"
					/>
				</Form.Item>

				<div style={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					marginBottom: 24
				}}>
					<Form.Item name="remember_me" valuePropName="checked" noStyle>
						<Checkbox onChange={handleChange}>Remember me</Checkbox>
					</Form.Item>

					<Link to="reset-password-email">Forgot password?</Link>
				</div>

				<Form.Item>
					<Button
					loading={loading}
					disabled={loading}
					type="primary"
					htmlType="submit"
					size="large"
					block
					style={{
						backgroundColor: '#6366f1',
						borderColor: '#6366f1',
						borderRadius: 8
					}}
					>
						Sign in
					</Button>
				</Form.Item>
			</Form>
		</>
	);
};

export default Login;
